(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("checkoutStep4Confirm", {
        templateUrl: "app/checkout/checkoutStep4Confirm.component.html",
        controller: ["frameworkService", "FormSubmitter", "checkoutService", "checkoutResource", "messageService", "$http", "$localStorage", "$rootScope", "$scope", "$state", "$uibModal", "$window", CheckoutStep4ConfirmCtrl],
        controllerAs: "vm"
    });
    function CheckoutStep4ConfirmCtrl(frameworkService, FormSubmitter, checkoutService, checkoutResource, messageService, $http, $localStorage, $rootScope, $scope, $state, $uibModal, $window) {
        var vm = this;
        vm.lockButton = false;
        vm.showCreditCardInfo = $state.params["creditCardInfo"] === "custom";
        vm.showPurchaseOrderForm = $state.params.purchaseOrder;
        vm.showForm = vm.showCreditCardInfo || vm.showPurchaseOrderForm;
        vm.mode = frameworkService.data.tenant.domain === "skillbuilder.co" ? "prod" : "qa";
        vm.months = [];
        vm.years = [];
        vm.frameworkData = frameworkService.data;
        for (var m = 1; m <= 12; m++) {
            vm.months.push(m);
        }
        var year = new Date().getFullYear();
        for (var y = 0; y <= 20; y++) {
            vm.years.push(new Date(year, 1, 1).getFullYear().toString().substr(-2));
            year++;
        }
        if (!checkoutService.wizard.isStep3Valid) {
            $state.go("main.checkout.step1");
            return;
        }
        if (checkoutService.wizard.step == 5) {
            $state.go("main.checkout.step5", { orderId: checkoutService.model.details.orderGuid }, { location: "replace" });
            return;
        }
        checkoutService.setStep(4);
        vm.model = checkoutService.model;
        vm.hasProductDiscount = vm.model.details.products.some(function (item) { return item.productDiscountAmount > 0; });
        if (vm.model.details.totalAmount === 0)
            vm.free = true;
        //The submit button text
        vm.continue = vm.free || vm.model.selectedPaymentId === "PurchaseOrder" || vm.model.selectedPaymentId === "Invoice";
        var removeOnRefreshCheckout;
        vm.confirmOrder = function () {
            if (vm.lockButton)
                return;
            vm.lockButton = true;
            if (vm.model.selectedPaymentId === "MonerisCheckout") {
                monerisConfirm();
            }
            else if (vm.model.selectedPaymentId === "BamboraCustomCheckout") {
                if (!vm.creditCardForm.$valid) {
                    vm.showErrors = true;
                    vm.lockButton = false;
                    return;
                }
                checkoutResource.pay({
                    paymentMethodId: vm.model.selectedPaymentId,
                    orderGuid: vm.model.details.orderGuid,
                    creditCard: vm.model.details.creditCard,
                    updateAddress: checkoutService.model.billingAddress.saveToAccount
                }, function (result) {
                    switch (result.type) {
                        case "SUCCESS":
                            checkoutService.wizard.isStep4Valid = true;
                            $state.go("main.checkout.step5", { orderId: checkoutService.model.details.orderGuid }, { location: "replace" });
                            break;
                        case "FAILURE":
                            messageService.error(result.errorMessage);
                            $state.go("main.checkout.step3", {}, { location: "replace" });
                            break;
                    }
                }, function (error) {
                    console.error(error);
                    messageService.error('common.genericCheckoutConnectionError');
                    $state.go("main.checkout.step3", {}, { location: "replace" });
                });
            }
            else if (vm.model.selectedPaymentId === "PurchaseOrder") {
                if (!vm.purchaseOrderForm.$valid) {
                    vm.showErrors = true;
                    vm.lockButton = false;
                    return;
                }
                checkoutResource.pay({
                    paymentMethodId: vm.model.selectedPaymentId,
                    orderGuid: vm.model.details.orderGuid,
                    purchaseOrderNumber: vm.model.details.purchaseOrderNumber,
                    updateAddress: checkoutService.model.billingAddress.saveToAccount
                }, function (result) {
                    switch (result.type) {
                        case "SUCCESS":
                            checkoutService.wizard.isStep4Valid = true;
                            $state.go("main.checkout.step5", { orderId: checkoutService.model.details.orderGuid }, { location: "replace" });
                            break;
                        case "FAILURE":
                            messageService.error(result.errorMessage);
                            $state.go("main.checkout.step3", {}, { location: "replace" });
                            break;
                    }
                }, function (error) {
                    messageService.error(error);
                    $state.go("main.checkout.step3", {}, { location: "replace" });
                });
            }
            else if (vm.model.selectedPaymentId === "Invoice") {
                checkoutResource.pay({
                    paymentMethodId: vm.model.selectedPaymentId,
                    orderGuid: vm.model.details.orderGuid,
                    updateAddress: checkoutService.model.billingAddress.saveToAccount
                }, function (result) {
                    switch (result.type) {
                        case "SUCCESS":
                            checkoutService.wizard.isStep4Valid = true;
                            $state.go("main.checkout.step5", { orderId: checkoutService.model.details.orderGuid }, { location: "replace" });
                            break;
                        case "FAILURE":
                            messageService.error(result.errorMessage);
                            $state.go("main.checkout.step3", {}, { location: "replace" });
                            break;
                    }
                }, function (error) {
                    messageService.error(error);
                    $state.go("main.checkout.step3", {}, { location: "replace" });
                });
            }
            else if (vm.model.selectedPaymentId === "BamboraCheckout") {
                //	window.open("https://web.na.bambora.com/scripts/payment/payment.asp?merchant_id=297830000&trnAmount=19.99&trnOrderNumber=12345TEST");
                checkoutResource.getBamboraUrl({ actionValue: vm.model.details.orderGuid }, function (result) {
                    switch (result.type) {
                        case "REDIRECT":
                            checkoutService.save();
                            window.open(result.redirectUrl, result.redirectTarget);
                            break;
                        case "SUCCESS":
                            vm.disable = false;
                            checkoutService.wizard.isStep3Valid = true;
                            $state.go("main.checkout.step4", {}, { location: "replace" });
                            break;
                        case "FAILURE":
                            messageService.error(result.errorMessage);
                            vm.disable = false;
                            break;
                    }
                });
            }
            else if (vm.model.selectedPaymentId === "StripeCheckout") {
                checkoutResource.getStripeCheckoutUrl({ actionValue: vm.model.details.orderGuid }, function (result) {
                    switch (result.type) {
                        case "REDIRECT":
                            checkoutService.save();
                            window.open(result.redirectUrl, result.redirectTarget);
                            break;
                        case "FAILURE":
                            messageService.error(result.errorMessage);
                            vm.disable = false;
                            break;
                    }
                });
            }
            else if (vm.model.selectedPaymentId === "AffiniPayHostedPage") {
                checkoutResource.getAffiniPayUrl({ actionValue: vm.model.details.orderGuid }, function (result) {
                    switch (result.type) {
                        case "REDIRECT":
                            var paymentWindow;
                            var modal = $uibModal.open({
                                templateUrl: "app/checkout/payments/affinipay/affiniPayRedirectModalView.html",
                                controller: ["$scope", function ($scope) {
                                        var vm = this;
                                        vm.waitingForPayment = false;
                                        vm.pay = function () {
                                            vm.paymentLink = result.redirectUrl;
                                            vm.waitingForPayment = true;
                                            paymentWindow = window.open(result.redirectUrl, result.redirectTarget);
                                        };
                                        vm.cancel = function () {
                                            if (paymentWindow)
                                                paymentWindow.close();
                                            $scope.$close();
                                        };
                                        //vm.headerText = headerText;
                                    }],
                                controllerAs: "vm",
                                size: "lg",
                                scope: $scope,
                                backdrop: "static",
                                animation: false
                            });
                            //checkoutService.save();
                            modal.result.then(function () {
                                $state.go("main.checkout.step3", {}, { location: "replace" });
                            }).catch(angular.noop);
                            removeOnRefreshCheckout = $rootScope.$on("RefreshCheckout", function (_event, transaction) {
                                //console.log("onRefreshCheckout: transaction", transaction);
                                if (transaction.id) {
                                    //Completed other order in another tab/browser
                                    if (transaction.id !== checkoutService.model.details.orderGuid)
                                        return;
                                    //all is good
                                    checkoutService.wizard.isStep4Valid = true;
                                    $state.go("main.checkout.step5", { orderId: checkoutService.model.details.orderGuid }, { location: "replace" });
                                }
                                else {
                                    //Transaction is either declined or cancelled by user
                                    checkoutService.model.error = true;
                                    $state.go("main.checkout.step3", {}, { location: "replace" });
                                    if (paymentWindow)
                                        paymentWindow.close();
                                }
                            });
                            break;
                        case "SUCCESS":
                            //vm.lockPaymentButtons[paymentMethodId] = false;
                            vm.disable = false;
                            checkoutService.wizard.isStep3Valid = true;
                            $state.go("main.checkout.step4", {}, { location: "replace" });
                            break;
                        case "FAILURE":
                            messageService.error(result.errorMessage);
                            //vm.lockPaymentButtons[paymentMethodId] = false;
                            vm.disable = false;
                            break;
                    }
                });
            }
            else {
                checkoutResource.complete({ orderGuid: vm.model.details.orderGuid, updateAccountAddress: vm.model.billingAddress.saveToAccount }, function (data) {
                    checkoutService.wizard.isStep4Valid = true;
                    $state.go("main.checkout.step5", { orderId: data.id }, { location: "replace" });
                }, function (errorData) {
                    messageService.error(errorData);
                    $state.go("main.checkout.step3", {}, { location: "replace" });
                });
            }
        };
        this.$onDestroy = function () {
            if (removeOnRefreshCheckout)
                removeOnRefreshCheckout();
        };
        function monerisConfirm() {
            if (vm.ticket) {
                loadMonerisCheckout();
                vm.lockButton = false;
                return;
            }
            checkoutResource.generateMonerisToken(vm.model, function (result) {
                checkoutService.save();
                if (result.ticket) {
                    vm.ticket = result.ticket;
                    console.log("Ticket:", vm.ticket);
                    loadMonerisCheckout();
                    vm.lockButton = false;
                }
                else {
                    vm.lockButton = false;
                    messageService.error(result.error);
                    $state.go("main.checkout.step1", {}, { location: "replace" });
                }
            }, function (error) {
                vm.lockButton = false;
                messageService.error(error);
            });
        }
        //if (vm.monerisCheckout)
        //	vm.monerisCheckout = null;
        function loadMonerisCheckout() {
            if (vm.monerisCheckout) {
                //this will occur when use clicks cancel and then pay now
                vm.monerisCheckout.setMode(vm.mode);
                vm.monerisCheckout.setCheckoutDiv("monerisCheckout");
                vm.monerisCheckout.startCheckout(vm.ticket);
                return;
            }
            vm.monerisCheckout = new window.monerisCheckout();
            vm.monerisCheckout.setMode(vm.mode);
            vm.monerisCheckout.setCheckoutDiv("monerisCheckout");
            if (!window.monerisCallbacksInitialized) {
                vm.monerisCheckout.setCallback("page_loaded", monerisPageLoad);
                vm.monerisCheckout.setCallback("cancel_transaction", monerisCancelTransaction);
                vm.monerisCheckout.setCallback("error_event", monerisErrorEvent);
                vm.monerisCheckout.setCallback("payment_receipt", monerisPaymentReceipt);
                vm.monerisCheckout.setCallback("payment_complete", monerisPaymentComplete);
                vm.monerisCheckout.setCallback("payment_submitted", monerisPaymentSubmitted);
                //vm.monerisCheckout.setCallback("remove_back_button", monerisRemoveBackButton);
                window.monerisCallbacksInitialized = true;
            }
            vm.monerisCheckout.startCheckout(vm.ticket);
        }
        function monerisPageLoad(response) {
            vm.monerisSuccess = false;
            vm.restartCheckout = false;
            console.log("monerisPageLoad", response);
        }
        function monerisCancelTransaction(response) {
            //console.log("monerisCancelTransaction", response);
            vm.monerisCheckout.closeCheckout();
        }
        function monerisErrorEvent(response) {
            //console.log("monerisErrorEvent", response);
            vm.monerisCheckout.closeCheckout();
        }
        function monerisPaymentReceipt(response) {
            console.log("monerisPaymentReceipt", response);
            var data = JSON.parse(response);
            checkoutResource.makeMonerisReceiptRequest({ ticket: data.ticket, orderGuid: checkoutService.model.details.orderGuid }, function (result) {
                console.log("makeMonerisReceiptRequest", checkoutService.model.details.orderGuid, result);
                vm.ticket = "";
                // if user reloads, force step 5 to load
                if (result.success) {
                    checkoutService.setStep(5);
                    vm.monerisSuccess = true;
                    delete $localStorage.storefrontCart3;
                    $rootScope.$broadcast("updateShoppingCartCount");
                }
                else {
                    checkoutService.setStep(4);
                    vm.restartCheckout = true;
                }
                checkoutService.save();
            });
        }
        //monerisComplete called when Order Confirmation Processing option set to "Use Own Page";
        function monerisPaymentComplete() {
            console.log("monerisPaymentComplete", vm.monerisSuccess, vm.restartCheckout);
            if (vm.monerisSuccess) {
                vm.monerisCheckout.closeCheckout();
                $state.go("main.checkout.step5", { orderId: checkoutService.model.details.orderGuid }, { location: "replace" });
            }
            else if (vm.restartCheckout) {
                vm.monerisCheckout.closeCheckout();
                //$state.go("main.checkout.step1", {}, { location: "replace" });
            }
            else {
                //no value set yet
                setTimeout(function () {
                    monerisPaymentComplete();
                }, 300);
            }
        }
        function monerisPaymentSubmitted(response) {
            console.log("monerisPaymentSubmitted", response);
        }
        function monerisRemoveBackButton() {
            console.log("monerisRemoveBackButton"); //doesn't actually call any code
        }
    }
}());
